import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as Styles from './CollapsedView.styles';

export type CollapsedViewProps = {
  reviewerScore: number;
  overviewNote: string;
  onClickToExpand: () => void;
};

export default function CollapsedView({
  reviewerScore,
  overviewNote,
  onClickToExpand,
}: CollapsedViewProps): JSX.Element {
  return (
    <div data-testid="technical-validation-review-collapsed-view">
      <Styles.OverviewNote>{overviewNote}</Styles.OverviewNote>

      <Styles.ScoreAndExpandBox>
        <Styles.ReviewerScoreBox>
          Reviewer Score: <span>{reviewerScore || '--'}</span>
        </Styles.ReviewerScoreBox>

        <Styles.ExpandBox onClick={onClickToExpand}>
          Expand
          <ExpandMoreIcon />
        </Styles.ExpandBox>
      </Styles.ScoreAndExpandBox>
    </div>
  );
}
